// Shared DOM-attribute names used by the rich text template variable system.
// Constants exist so the parsers, serializers and TipTap extensions all agree
// on the same wire format without duplicating magic strings.

export const TEMPLATE_VARIABLE_ATTR = 'data-template-variable';
export const TEMPLATE_VARIABLE_BLOCK_ATTR = 'data-template-variable-block';
